import { IComponent } from "./type/dynamic-rendering.interfaces";
//@ts-ignore
import SingleDoor from './../asset/svg/DoorStyle/SingleDoor.svg';
//@ts-ignore
import DoubleDoor from './../asset/svg/DoorStyle/DoubleDoor.svg';
//@ts-ignore
import TripleDoor from './../asset/svg/DoorStyle/TripleDoor.svg';
//@ts-ignore
import PcVerticalTri from './../asset/svg/SingleDoorStyle/PcVerticalTri.svg';
//@ts-ignore
import DecorationXTrim from './../asset/svg/SingleDoorStyle/DecorationXTrim.svg';
//@ts-ignore
import none from './../asset/svg/SingleDoorStyle/none.svg';
//@ts-ignore
import LeftHandOutswing from './../asset/svg/DoorSwing/Left Hand Outswing.svg';
//@ts-ignore
import RightHandOutswing from './../asset/svg/DoorSwing/Right Hand Outswing.svg';
//@ts-ignore
import LeftHandInswing from './../asset/svg/DoorSwing/Left Hand Inswing.svg';
//@ts-ignore
import RightHandInswing from './../asset/svg/DoorSwing/Right Hand Inswing.svg';
//@ts-ignore
import AngledFrame from './../asset/svg/Decorative Trim/Angled Frame.svg';
//@ts-ignore
import SquareFrame from './../asset/svg/Decorative Trim/Square Frame.svg'
// //@ts-ignore
// const SingleDoor = require('./../asset/svg/DoorStyle/SingleDoor.svg')
// //@ts-ignore
// const DoubleDoor = require('./../asset/svg/DoorStyle/DoubleDoor.svg')
// //@ts-ignore
// const TripleDoor = require('./../asset/svg/DoorStyle/TripleDoor.svg')
// //@ts-ignore
// const PcVerticalTri = require('./../asset/svg/SingleDoorStyle/PcVerticalTri.svg')
// //@ts-ignore
// const DecorationXTrim = require('./../asset/svg/SingleDoorStyle/DecorationXTrim.svg')
// //@ts-ignore
// const none = require('./../asset/svg/SingleDoorStyle/none.svg')
// //@ts-ignore
// const LeftHandOutswing = require('./../asset/svg/DoorSwing/Left Hand Outswing.svg')
// //@ts-ignore
// const RightHandOutswing = require('./../asset/svg/DoorSwing/Right Hand Outswing.svg')
// //@ts-ignore
// const LeftHandInswing = require('./../asset/svg/DoorSwing/Left Hand Inswing.svg')
// //@ts-ignore
// const RightHandInswing = require('./../asset/svg/DoorSwing/Right Hand Inswing.svg')
// //@ts-ignore
// const AngledFrame = require('./../asset/svg/Decorative Trim/Angled Frame.svg')
// //@ts-ignore
// const SquareFrame = require('./../asset/svg/Decorative Trim/Square Frame.svg')

export const settingForSides: IComponent[] = [
    {
        type: 'SettingOpening',
        data: {
            id: 'Product__Sides__FramedOpening',
            label: 'Framed Opening',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            embeddedView: [
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Width in Inches',
                        id: 'Product__Sides__FramedOpening_WidthinInches',
                        typeOptions: 'configurationOptions',
                        isRequired: true,
                        values: [
                            {
                                label: '10',
                                value: '10'
                            },
                            {
                                label: '12',
                                value: '12'
                            },
                            {
                                label: '14',
                                value: '14'
                            },
                        ],
                    }
                },
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Height in Inches',
                        id: 'Product__Sides__FramedOpening_HeightinInches',
                        typeOptions: 'configurationOptions',
                        isRequired: true,
                        values: [
                            {
                                label: '10',
                                value: '10'
                            },
                            {
                                label: '12',
                                value: '12'
                            },
                            {
                                label: '14',
                                value: '14'
                            },
                        ],
                    }
                },
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Height from floor in Inches',
                        id: 'Product__Sides__FramedOpening_HeightfromfloorinInches',
                        typeOptions: 'configurationOptions',
                        isRequired: true,
                        values: [
                            {
                                label: '10',
                                value: '10'
                            },
                            {
                                label: '12',
                                value: '12'
                            },
                            {
                                label: '14',
                                value: '14'
                            },
                        ],
                    }
                },




            ]
        }
    },
    {
        type: 'SettingOpening',
        data: {
            id: 'Product__Sides__SingleWindow',
            label: 'Single Window',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            embeddedView: [
                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Window Style',
                        id: 'Product__Sides__SingleWindow_WindowStyle',
                        typeOptions: 'groupingOptions',
                        isRequired: false,
                        additionalProperties: {
                            groupGap: true,
                            maxWidth: '270px',
                        },
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Insulated Vinyl Clay',
                                    id: 'Product__Sides__SingleWindow_InsulatedVinylClay',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Insulated Vinyl White',
                                    id: 'Product__Sides__SingleWindow_InsulatedVinylWhite',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Non-insulated Aluminum White',
                                    id: 'Product__Sides__SingleWindow_NoninsulatedAluminumWhite',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }
                                }
                            },
                        ]
                    }
                },


                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Choose Window',
                        id: 'Product__Sides__SingleWindow_DeliveryMethod',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '2x3 Window - Ins. Vinyl White - Grid',
                                value: '2x3 Window - Ins. Vinyl White - Grid'
                            },
                            {
                                label: '2x3 Window - Ins. Vinyl White - Grid',
                                value: '2x3 Window - Ins. Vinyl White - Grid'
                            },
                            {
                                label: '3x5 Window - Ins. Vinyl White - No Grid',
                                value: '3x5 Window - Ins. Vinyl White - No Grid'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '308px',
                        }
                    }
                },

            ]
        }
    },
    {
        type: 'SettingOpening',
        data: {
            id: 'Product__Sides__DoubleWindowBank',
            label: 'Double Window Bank',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            embeddedView: [
                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Window Style',
                        id: 'Product__Sides__DoubleWindowBank_WindowStyle',
                        typeOptions: 'groupingOptions',
                        isRequired: false,
                        additionalProperties: {
                            groupGap: true,
                            maxWidth: '270px',
                        },
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Insulated Vinyl Clay',
                                    id: 'Product__Sides__DoubleWindowBank_InsulatedVinylClay',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Insulated Vinyl White',
                                    id: 'Product__Sides__DoubleWindowBank_InsulatedVinylWhite',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Non-insulated Aluminum White',
                                    id: 'Product__Sides__DoubleWindowBank_Non-insulatedAluminumWhite',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }
                                }
                            },
                        ]
                    }
                },


                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Choose Window',
                        id: 'Product__Sides__DoubleWindowBank_DeliveryMethod',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '2x3 Window - Ins. Vinyl White - Grid',
                                value: '2x3 Window - Ins. Vinyl White - Grid'
                            },
                            {
                                label: '2x3 Window - Ins. Vinyl White - Grid',
                                value: '2x3 Window - Ins. Vinyl White - Grid'
                            },
                            {
                                label: '3x5 Window - Ins. Vinyl White - No Grid',
                                value: '3x5 Window - Ins. Vinyl White - No Grid'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '308px',
                        }
                    }
                },

            ]
        }
    },
    {
        type: 'SettingOpening',
        data: {
            id: 'Product__Sides__TripleWindowBank',
            label: 'Triple Window Bank',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            embeddedView: [
                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Window Style',
                        id: 'Product__Sides__TripleWindowBank_WindowStyle',
                        typeOptions: 'groupingOptions',
                        isRequired: false,
                        additionalProperties: {
                            groupGap: true,
                            maxWidth: '270px',
                        },
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Insulated Vinyl Clay',
                                    id: 'Product__Sides__TripleWindowBank_InsulatedVinylClay',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Insulated Vinyl White',
                                    id: 'Product__Sides__TripleWindowBank_InsulatedVinylWhite',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Non-insulated Aluminum White',
                                    id: 'Product__Sides__TripleWindowBankAluminumWhite',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }
                                }
                            },
                        ]
                    }
                },


                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Choose Window',
                        id: 'Product__Sides__TripleWindowBank_DeliveryMethod',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '2x3 Window - Ins. Vinyl White - Grid',
                                value: '2x3 Window - Ins. Vinyl White - Grid'
                            },
                            {
                                label: '2x3 Window - Ins. Vinyl White - Grid',
                                value: '2x3 Window - Ins. Vinyl White - Grid'
                            },
                            {
                                label: '3x5 Window - Ins. Vinyl White - No Grid',
                                value: '3x5 Window - Ins. Vinyl White - No Grid'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '308px',
                        }
                    }
                },

            ]
        }
    },
    {
        type: 'SettingOpening',
        data: {
            id: 'Product__Sides__ShedDoor',
            label: 'Shed Door',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            embeddedView: [


                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Choose Door',
                        id: 'Product__Sides__ShedDoor_Choose Door',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        embeddedView: [
                            {
                                type: 'ImgRadioST',
                                data: {
                                    label: 'Choose Door',
                                    id: 'Product__Sides__ShedDoor_Choose Door',
                                    typeOptions: 'configurationOptions',
                                    isRequired: false,
                                    values: [
                                        {
                                            id: 'SingleDoor',
                                            imgUrl: SingleDoor,
                                        },
                                        {
                                            id: 'DoubleDoor',
                                            imgUrl: DoubleDoor,
                                        },
                                        {
                                            id: 'TripleDoor',
                                            imgUrl: TripleDoor,
                                        },
                                    ]

                                }
                            },
                        ]

                    }
                },
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Choose Door',
                        id: 'Product__Sides__ShedDoor_Choose Door',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '72"x72" Double Shed Door',
                                value: '72"x72" Double Shed Door'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '308px',
                        }
                    }
                },
                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Decorative Trim',
                        id: 'Product__Sides__ShedDoor_Choose Door',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        embeddedView: [
                            {
                                type: 'ImgRadioST',
                                data: {
                                    label: 'Choose Door',
                                    id: 'ChooseDoor',
                                    typeOptions: 'configurationOptions',
                                    isRequired: false,
                                    values: [
                                        {
                                            id: 'PcVerticalTri',
                                            imgUrl: PcVerticalTri,
                                        },
                                        {
                                            id: 'DecorationXTrim',
                                            imgUrl: DecorationXTrim,
                                        },

                                        {
                                            id: 'none',
                                            imgUrl: none,
                                        },
                                    ]

                                }
                            },
                        ]

                    }
                },

                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Window in Door Option',
                        id: 'Product__Sides__Shed Door_WindowDoorOption',
                        typeOptions: 'groupingOptions',
                        isRequired: false,
                        additionalProperties: {
                            groupGap: true,
                            maxWidth: '270px',
                        },
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Transom Window',
                                    id: 'TransomWindow',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },


                        ]
                    }
                },
                {
                    type: 'LineParamRadio',
                    data: {
                        id: 'Product__Sides__ShedDoor_DoorSwing',
                        label: 'Door Swing',
                        isRequired: true,
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                imgUrl: LeftHandOutswing,
                                label: 'Left Hand Outswing',
                                value: 'LeftHandOutswing'
                            },
                            {
                                imgUrl: RightHandOutswing,
                                label: 'Right Hand Outswing',
                                value: 'RightHandOutswing'
                            },
                            // {
                            //     imgUrl: '/assets/svg/DoorSwing/DoubleDoorOutside.svg',
                            //     label: 'Outswing',
                            //     value: 'Outswing'
                            // },
                            // {
                            //     imgUrl: '/assets/svg/DoorSwing/DoubleDoorInside.svg',
                            //     label: 'Inswing',
                            //     value: 'Inswing'
                            // }, 
                        ],
                    }
                },
            ]
        }
    },
    {
        type: 'SettingOpening',
        data: {
            id: 'Product__Sides__ResidentialDoor',
            label: 'Residential Door',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            embeddedView: [


                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Choose Door',
                        id: 'Product__Sides__ResidentialDoor_ChooseDoor',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        embeddedView: [
                            {
                                type: 'ImgRadioST',
                                data: {
                                    label: 'Choose Door',
                                    id: 'Product__Sides__ResidentialDoor_ChooseDoor',
                                    typeOptions: 'configurationOptions',
                                    isRequired: false,
                                    values: [
                                        {
                                            id: 'SingleDoor',
                                            imgUrl: SingleDoor,
                                        },
                                        {
                                            id: 'DoubleDoor',
                                            imgUrl: DoubleDoor,
                                        },

                                    ]

                                }
                            },
                        ]

                    }
                },
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Choose Door',
                        id: 'Product__Sides__ResidentialDoor_ChooseDoor',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '72"x72" Double Shed Door',
                                value: '72"x72" Double Shed Door'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '308px',
                        }
                    }
                },
                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Decorative Trim',
                        id: 'Product__Sides__ResidentialDoor_ChooseDoor',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        embeddedView: [
                            {
                                type: 'ImgRadioST',
                                data: {
                                    label: 'Choose Door',
                                    id: 'Product__Sides__ResidentialDoor_Choose Door',
                                    typeOptions: 'configurationOptions',
                                    isRequired: false,
                                    values: [
                                        {
                                            id: 'none',
                                            imgUrl: none,
                                        },
                                    ]

                                }
                            },
                        ]

                    }
                },

                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Window in Door Option',
                        id: 'Product__Sides__ResidentialDoor_WindowDoorOption',
                        typeOptions: 'groupingOptions',
                        isRequired: false,
                        additionalProperties: {
                            groupGap: true,
                            maxWidth: '270px',
                        },
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Transom Window',
                                    id: 'Product__Sides__ResidentialDoor_TransomWindow',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },


                        ]
                    }
                },
                {
                    type: 'LineParamRadio',
                    data: {
                        id: 'Product__Sides__ResidentialDoor_DoorSwing',
                        label: 'Door Swing',
                        isRequired: true,
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                imgUrl: LeftHandOutswing,
                                label: 'Left Hand Outswing',
                                value: 'LeftHandOutswing'
                            },
                            {
                                imgUrl: RightHandOutswing,
                                label: 'Right Hand Outswing',
                                value: 'RightHandOutswing'
                            },
                            {
                                imgUrl: LeftHandInswing,
                                label: 'Left Hand Inswing',
                                value: 'LeftHandInswing'
                            },
                            {
                                imgUrl: RightHandInswing,
                                label: 'Right Hand Inswing',
                                value: 'RightHandInswing'
                            },

                        ],


                    }
                },
            ]
        }
    },
    {
        type: 'SettingOpening',
        data: {
            id: 'Product__Sides__OverheadDoor',
            label: 'Overhead Door',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            embeddedView: [


                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Choose Door',
                        id: 'Product__Sides__OverheadDoor_ChooseDoor',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '72"x72" Double Shed Door',
                                value: '72"x72" Double Shed Door'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '308px',
                        }
                    }
                },
                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Window in Door Option',
                        id: 'Product__OverheadDoor__ResidentialDoor_WindowDoorOption',
                        typeOptions: 'groupingOptions',
                        isRequired: false,
                        additionalProperties: {
                            groupGap: true,
                            maxWidth: '270px',
                        },
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Transom Window',
                                    id: 'Product__Sides__ResidentialDoor_TransomWindow',
                                    typeOptions: 'configurationOptions',
                                    additionalStyles: {
                                        colorText: '#000',
                                        fontSize: '14px',
                                    }

                                }
                            },


                        ]
                    }
                },
                {
                    type: 'LineParamGT',
                    data: {
                        label: 'Decorative Trim',
                        id: 'Product__Sides__OverheadDoor_DecorativeTrim11111',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        embeddedView: [
                            {
                                type: 'ImgRadioST',
                                data: {
                                    label: 'Choose Door',
                                    id: 'Product__Sides__OverheadDoor_ChooseDoor111',
                                    typeOptions: 'configurationOptions',
                                    isRequired: false,
                                    values: [
                                        {
                                            imgUrl: AngledFrame,
                                            label: 'Angled Frame',
                                            value: 'Angled Frame',
                                            id: 'Angled Frame',
                                        },
                                        {
                                            imgUrl: SquareFrame,
                                            label: 'Square Frame',
                                            value: 'Square Frame',
                                            id: 'Square Frame',
                                        },

                                    ]

                                }
                            },
                        ]

                    }
                },
            ]
        }
    },
    {
        type: 'SettingOpening',
        data: {
            id: 'DormerItems',
            label: 'Dormer',
            typeOptions: 'groupingOptionsSwitchingOpening',
            switchingOptions: false,
            isRemoveSection: true,
            // dependencySettings: [
            //     {
            //         dependencyType: 'isVisible',
            //         idParams: 'orientationSide',
            //         isValue: ['SideB', 'SideD']
            //     }

            // ],
            embeddedView: [
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Dormer Window',
                        id: 'Product__Sides__Dormer_Window',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '36"x72" Single Dutch Door',
                                value: '36"x72" Single Dutch Door'
                            },
                            {
                                label: '72"x72" Double Shed Door',
                                value: '72"x72" Double Shed Door'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '279px',
                        }
                    }
                },
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Number Dormer Windows ',
                        id: 'Product__Sides__Number_Dormer_Windows ',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [
                            {
                                label: '4 Windows',
                                value: '4 Windows'
                            },
                            {
                                label: '3 Windows',
                                value: '3 Windows'
                            },
                            {
                                label: '2 Windows',
                                value: '2 Windows'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '279px',
                        }
                    }
                },
            ]
        }
    }
]